import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";

@Component({
    selector: 'app-confirm-popup',
    templateUrl: './confirm-popup.component.html',
    styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmPopupComponent implements OnInit {
    @Input() data = null;
    @Output() send = new EventEmitter();
    message = '';
    TotalPrice = 0;
    Paid = 0;
    TotalConfirm = 0;
    constructor(
        public bsModal: BsModalRef,
    ) {
    }

    ngOnInit() {
        if (this.data != null){
            this.data.orderItems.map(i => {
                this.TotalPrice += i.Quantity * i.info.Price;
            })
        }
    }
    hide(){
        this.bsModal.hide()
    }
    confirm(){
        console.log([this.Paid, this.TotalPrice, this.TotalConfirm]);
        if (this.TotalConfirm != this.TotalPrice){
            this.message  = 'Nhập sai tổng tiền vui lòng nhập lại';
            return;
        }
        this.send.emit(this.Paid);
        this.hide();
    }
}
